module.exports = __webpack_public_path__ + "img/z_white_logo.8764f605.png";